import axios from "axios";
import { BACKEND_URL, API_VERSION } from "@config/constants";

export const fetchShopTestimonials = (shopfrontId, pageNum) => {
  return axios.get(`${BACKEND_URL}/${API_VERSION}/shop-testimonial`, {
    params: { shopfront_id: shopfrontId, page: pageNum },
  });
};
